import { lazy } from "react";

export const grievanceRoutes = [
  { path: "/GrievanceMechanism", component: lazy(() => import("../../Components/Taxes/GrievanceMechanism/GrievanceMechanism")) },
  { path: "/TicketStatusReport", component: lazy(() => import("../../Components/Taxes/RegisterReports/UserRoleTicketReport")) },
  { path: "/GrivenceReportAllLevels", component: lazy(() => import("../../Components/Taxes/GrievanceMechanism/GrivenceReportAllLevels")) },
];
